var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHardware1Line91(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hardware_1-line-91") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 0.5h-15c-1.1 0-2 0.9-2 2v27c0 1.1 0.9 2 2 2h15c1.1 0 2-0.9 2-2v-27c0-1.1-0.9-2-2-2zM7.5 5.5h17v19h-17v-19zM7.5 2.5c0-0.55 0.45-1 1-1h15c0.55 0 1 0.45 1 1v2h-17v-2zM24.5 29.5c0 0.55-0.45 1-1 1h-15c-0.55 0-1-0.45-1-1v-4h17v4zM16 29.5c0.85 0 1.5-0.65 1.5-1.5s-0.65-1.5-1.5-1.5-1.5 0.65-1.5 1.5 0.65 1.5 1.5 1.5zM16 27.5c0.3 0 0.5 0.2 0.5 0.5s-0.2 0.5-0.5 0.5-0.5-0.2-0.5-0.5 0.2-0.5 0.5-0.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardware1Line91);
export default __webpack_public_path__ + "static/media/hardware_1-line-91.7be704c60fa2752399990f86a6e6ab14.svg";
export { ForwardRef as ReactComponent };